/**
 * @generated SignedSource<<7b0edc1ff513f904835abcc1612c3123>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UserErrorCode = "INVALID_CREDENTIALS" | "INVALID_ARGUMENTS" | "UNAUTHORIZED_ACCESS" | "CONFLICTING_ORGANIZATIONS" | "RECORD_NOT_FOUND" | "%future added value";
export type CreateValveConnectorInput = {
  name: string;
  clientMutationId?: string | null;
};
export type createPageCreateValveConnectorMutation$variables = {
  input: CreateValveConnectorInput;
};
export type createPageCreateValveConnectorMutationVariables = createPageCreateValveConnectorMutation$variables;
export type createPageCreateValveConnectorMutation$data = {
  readonly createValveConnector: {
    readonly valveConnector: {
      readonly id: string;
      readonly createdAt: any;
      readonly name: string;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly code: UserErrorCode;
      readonly fields: ReadonlyArray<{
        readonly fieldName: string;
        readonly message: string;
      }> | null;
    }>;
  } | null;
};
export type createPageCreateValveConnectorMutationResponse = createPageCreateValveConnectorMutation$data;
export type createPageCreateValveConnectorMutation = {
  variables: createPageCreateValveConnectorMutationVariables;
  response: createPageCreateValveConnectorMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateValveConnectorPayload",
    "kind": "LinkedField",
    "name": "createValveConnector",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ValveConnector",
        "kind": "LinkedField",
        "name": "valveConnector",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserFieldError",
            "kind": "LinkedField",
            "name": "fields",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fieldName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createPageCreateValveConnectorMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createPageCreateValveConnectorMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b536b3eb0d0f1ca695ae9f03c70393f4",
    "id": null,
    "metadata": {},
    "name": "createPageCreateValveConnectorMutation",
    "operationKind": "mutation",
    "text": "mutation createPageCreateValveConnectorMutation(\n  $input: CreateValveConnectorInput!\n) {\n  createValveConnector(input: $input) {\n    valveConnector {\n      id\n      createdAt\n      name\n    }\n    errors {\n      code\n      fields {\n        fieldName\n        message\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8a8be752adf656527b3af83b1f10efae";

export default node;
